import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import stlyes from "./InstallationPrompt.module.css";

import AppImage from './takbir-app-img.png';
import AppImageMobile from './takbir-app-img-mobile.png';
import Image from "next/image";
import { InstallIcon } from "./InstallIcon";

function InstallationPrompt(props) {
  const [open, setOpen] = React.useState(true);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className={stlyes.MdlResponsiveFullScreen}>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        className={stlyes.MdFullScreenContainer}
      >


        <DialogContent className={stlyes.ModalBody}>

          <div className={stlyes.ModalBodyContent}>
            <div className={stlyes.AppImgDekstop}><Image src={AppImage} /></div>
            <div className={stlyes.AppImgMobile}><Image src={AppImageMobile} /></div>

            <div className={stlyes.Details}>

              <div className={stlyes.DetailsTopSection}>

                <img
                  className={stlyes.OrgLogo}
                  src="https://cdn.mytakbir.com/static-assets/logos/takbir-lms-learning-management-system-muslim-logo-3x.png"
                  width={88}
                  height={26}
                />

                <span className={stlyes.ModaCloseIcon}>
                  <CloseRoundedIcon
                    className={stlyes.ModaClose}
                    onClick={() => handleClose()}
                  />
                </span>
              </div>

              <div className={stlyes.Content}>
                <div className={stlyes.Title}>Install Takbir</div>
                <div className={stlyes.Description}>Add Takbir to your device for a faster, app-like experience.
                  Click the Install button below to add takbir to your home screen.</div>
              </div>

              <div className={stlyes.DesktopView}>
                <div className={stlyes.FooterButtonContainer}>
                  <div className={stlyes.FooterButtonContainerInner}>
                    <Button
                      className={stlyes.Cancel}
                      variant="contained"

                      onClick={() => handleClose()}
                    >
                      Not now
                    </Button>
                    <Button
                      className={stlyes.Action}
                      variant="contained"
                      onClick={() => handleConfirm()}
                    >
                      <InstallIcon /> Install
                    </Button>
                  </div>
                </div>
              </div>

              <div className={stlyes.MobileView}>
                <div className={stlyes.FooterButtonContainer}>
                  <div className={stlyes.FooterButtonContainerInner}>

                    <Button
                      className={stlyes.Action}
                      variant="contained"
                      onClick={() => handleConfirm()}
                    >
                      <InstallIcon /> Install
                    </Button>

                    <Button
                      className={stlyes.Cancel}
                      variant="contained"

                      onClick={() => handleClose()}
                    >
                      Not now
                    </Button>
                  </div>
                </div>
              </div>


            </div>

          </div>

        </DialogContent>






      </Dialog>
    </div>
  );
}

export default InstallationPrompt;
